const OPEN_CLASS = "pwa-layers-open";

function attach(ctrl) {
  if (!ctrl || ctrl.dataset.pwaManaged === "1") return;
  ctrl.dataset.pwaManaged = "1";
  ctrl.classList.remove("leaflet-control-layers-expanded");
  ctrl.classList.remove(OPEN_CLASS);

  const toggle = ctrl.querySelector(".leaflet-control-layers-toggle");
  if (toggle) {
    const tap = (e) => {
      e.preventDefault();
      e.stopPropagation();
      ctrl.classList.toggle(OPEN_CLASS);
    };
    toggle.addEventListener("click", tap, true);
    toggle.addEventListener("touchend", tap, { passive: false });
  }
  ctrl.addEventListener("click", (e) => e.stopPropagation());
}

function setupOutsideClose() {
  const handler = (e) => {
    document.querySelectorAll(`.leaflet-control-layers.${OPEN_CLASS}`).forEach(ctrl => {
      if (!ctrl.contains(e.target)) ctrl.classList.remove(OPEN_CLASS);
    });
  };
  document.addEventListener("click", handler, true);
  document.addEventListener("touchstart", handler, { capture: true, passive: true });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.querySelectorAll(`.leaflet-control-layers.${OPEN_CLASS}`)
        .forEach(c => c.classList.remove(OPEN_CLASS));
    }
  });
}

function init() {
  document.querySelectorAll(".leaflet-control-layers").forEach(attach);
  const obs = new MutationObserver(() => {
    document.querySelectorAll(".leaflet-control-layers").forEach(attach);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setupOutsideClose();
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}
